<template>
  <div class="rwa_delivery_div">
    <div class="rwa_delivery_page_01">
      <Menu/>
    </div>

    <div class="rwa_delivery_page_02">

      <img class="rwa_delivery_page_02_bj01" src="../../assets/images/yusbj1.png"/>
      <img class="rwa_delivery_page_02_bj02" src="../../assets/images/yusbj2.png"/>

      <div class="rwa_delivery_page_021">
        <div class="rwa_delivery_page_0211">
          {{ deliveryType ? '正在兑换' : '项目交割'}}
        </div>

        <div class="rwa_delivery_page_0212">
          <div :class="deliveryType === 0 ? 'rwa_delivery_page_02121 rwa_delivery_page_0212_select' : 'rwa_delivery_page_02121'" @click="selectDeliveryType(0)">
            项目交割
          </div>
          <div :class="deliveryType === 1 ? 'rwa_delivery_page_02121 rwa_delivery_page_0212_select' : 'rwa_delivery_page_02121'" @click="selectDeliveryType(1)">
            正在兑换
          </div>
        </div>

        <div class="rwa_delivery_page_0213">
          <div class="rwa_delivery_page_02131" v-if="deliveryDataList.length > 0">
            <div class="rwa_delivery_page_02131_div" v-for="(item, index) in deliveryDataList" :key="index">
              <div class="rwa_delivery_page_02131_div1">
                <img src="../../assets/images/image_yubi.png"/>

                <div class="rwa_delivery_page_02131_div11" v-if="deliveryType === 1">
                  兑换剩余时间:6天59分59秒
                </div>
                <div class="rwa_delivery_page_02131_div12" v-if="deliveryType === 0">
                </div>
              </div>

              <div class="rwa_delivery_page_02131_div2">
                春秋战国玉器
              </div>

              <div class="rwa_delivery_page_02131_div3" v-if="deliveryType === 0" @click="toDelivery()">交割</div>
              <div class="rwa_delivery_page_02131_div3" v-if="deliveryType === 1" @click="toExchange()">参与兑换</div>
            </div>
          </div>

          <div class="rwa_delivery_page_02132" v-if="deliveryDataList.length === 0">
            {{ deliveryDataListLoding ? 'Loading...' : 'No Data...' }}
          </div>

          <div class="rwa_delivery_page_02133">
            <el-pagination
                :background="true"
                @current-change="getDeliveryDataListPage"
                layout="prev, pager, next"
                :page-size="limitNum"
                :total="totalNum">
            </el-pagination>
          </div>
        </div>

        <div class="rwa_delivery_page_0214">
          <div class="rwa_delivery_page_02141">
            1、交割条件
          </div>
          <div class="rwa_delivery_page_02142">
            买方需要支付51%，即510.000.000代币买方需支付BNB建立兑换池(兑换池用来兑换剩余49%的代币，持有49%代币的用户可以通过兑换池按照固定价格将代币兑换成BNB)
          </div>
          <div class="rwa_delivery_page_02141">
            2、交割方法
          </div>
          <div class="rwa_delivery_page_02142">
            • 将51%代币转入0x0000000000000000000000000000dEaD地址
          </div>
          <div class="rwa_delivery_page_02142">
            • 将BNB注入兑换池，通过智能合约按照固定价格对剩余49%的代币进行兑换
          </div>
          <div class="rwa_delivery_page_02142">
            • 完成以上可以获得MY，MY可以兑换实体古董
          </div>
          <div class="rwa_delivery_page_02141">
            备注:
          </div>
          <div class="rwa_delivery_page_02142">
            • 兑换价格:过去7天的市场平均成交价(不足7天，按实际天数计算)
          </div>
          <div class="rwa_delivery_page_02142">
            • 兑换时间:持续30天
          </div>
          <div class="rwa_delivery_page_02141">
            举例:
          </div>
          <div class="rwa_delivery_page_02142">
            过去7天平均价格为0.0001U，买家需要出0.0001*4.9亿=49.000U，创建兑换池
          </div>
        </div>
      </div>

      <div class="rwa_delivery_page_03">
        <Bottom/>
      </div>
    </div>

    <el-dialog
        :visible.sync="colDeliveryVisible"
        width="500px"
        :show-close="false">
      <div class="rwa_delivery_dialog">
        <div class="rwa_delivery_dialog_1">
          <div class="rwa_delivery_dialog_11">交割费用</div>

          <img src="../../assets/images/guanbi.png" @click="colDeliveryVisible = false"/>
        </div>

        <div class="rwa_delivery_dialog_2">
          <div class="rwa_delivery_dialog_21">
            <div class="rwa_delivery_dialog_211">
              <div class="rwa_delivery_dialog_2111">消耗</div>
              <div class="rwa_delivery_dialog_2112">余额：{{ setDecimal(consumeTokenBalance, 6) }} RWA</div>
            </div>
            <div class="rwa_delivery_dialog_212">
              <div class="rwa_delivery_dialog_2121">
                RWA
                <img src="../../assets/images/ART.png"/>
              </div>
              <div class="rwa_delivery_dialog_2122">
                {{ consumeTokenNum }}
              </div>
            </div>
          </div>

          <div class="rwa_delivery_dialog_22">
            <div class="rwa_delivery_dialog_221">
              <div class="rwa_delivery_dialog_2211">消耗</div>
              <div class="rwa_delivery_dialog_2212">余额：{{ setDecimal(bnbBalance, 6) }} BNB</div>
            </div>
            <div class="rwa_delivery_dialog_222">
              <div class="rwa_delivery_dialog_2221">
                BNB
                <img src="../../assets/images/BNB.png"/>
              </div>
              <div class="rwa_delivery_dialog_2222">
                {{ consumeBnbNum }}
              </div>
            </div>
          </div>

          <div class="rwa_delivery_dialog_23" @click="onDelivery()">确认交割</div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Menu from "@/components/Menu.vue";
import Bottom from "@/components/Bottom.vue";
import { cutAccount, lang, BigNumberMul } from "@/tools";
import toolUtils, { setDecimal, formatNumberKx, conversionTimestampFormatObj } from "@/tools/toolUtils";
import { mixin1 } from "@/tools/mixins";
import * as metaMaskTools from "@/tools/chain";
import transfer from "@/tools/transfer";
import {
  debug,
  uploadHost
} from "@/config";

export default {
  name: "Delivery",
  components: {
    Menu,
    Bottom
  },
  mixins: [mixin1],
  data() {
    return {
      imgHost: uploadHost,
      deliveryType: 0, // 0 项目交割 1 正在兑换
      pageNum: 1,
      limitNum: 10,
      totalNum: 0,
      deliveryDataListLoding: false,
      deliveryDataList: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
      ],
      colDeliveryVisible: false,
      consumeToken: null,
      consumeTokenBalance: 0,
      consumeTokenNum: 0,
      bnbBalance: 0,
      consumeBnbNum: 0,
    }
  },
  watch: {},
  created() {
    setTimeout(() => {
      this.onAccountsChanged();
    }, 1000);
  },
  mounted() {
  },
  destroyed() {
  },
  beforeDestroy() {
  },
  methods: {
    lang(key){
      return lang(key);
    },
    cutAccount(account, num) {
      return cutAccount(account, num);
    },
    setDecimal(num, numDecimalMax) {
      return setDecimal(num, numDecimalMax, false, false);
    },
    formatNumberKx(num, decimals) {
      return formatNumberKx(num, decimals);
    },
    toTextDate(time) {
      return toolUtils.toTextDate(time);
    },
    openConnectWallet() {
      this.$store.commit('setState', {
        connectWalletShow: true
      });
    },
    toConnectWalletMining() {
      this.$message.warning(lang('qxljqb'));

      this.openConnectWallet();
    },
    selectDeliveryType(typeNum) {
      this.deliveryType = parseInt(typeNum);
    },
    getDeliveryDataListPage() {
      this.deliveryDataListLoding = true;

      this.deliveryDataListLoding = false;
    },

    async getBnbBbalance() {
      try {
        if (this.$store.state.accounts.length > 0) {
          await metaMaskTools.getBalance(this.$store.state.accounts[0]).then(async (res) => {
            if (res) {
              this.bnbBalance = parseInt(res) / 1e18;
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getConsumeTokenBalance() {
      try {
        if (this.$store.state.accounts.length > 0) {
          await metaMaskTools.erc20BasicPublicCall(this.consumeToken, 'balanceOf', [this.$store.state.accounts[0]]).then(async (res) => {
            if (res) {
              this.consumeTokenBalance = parseInt(res) / 1e18;
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    async toDelivery() {
      this.colDeliveryVisible = true;

      await this.getBnbBbalance();
    },
    async onDelivery() {
      this.$message.warning('Coming soon!');
      return;

      // this.$store.commit('setState', {
      //   transactionType: 2
      // });
    },
    toExchange() {
      this.$message.warning('Coming soon!');
      return;
    }
  }
}
</script>

<style scoped lang="less">
.rwa_delivery_div {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;

  .rwa_delivery_page_01 {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .rwa_delivery_page_02::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .rwa_delivery_page_02 {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    top: 84px;
    bottom: 0;
    background: #151515;

    .rwa_delivery_page_02_bj01 {
      position: absolute;
      top: 0;
      left: 0;
      width: 50%;
      @media (max-width: 767px) {
        display: none;
      }
    }

    .rwa_delivery_page_02_bj02 {
      position: absolute;
      top: 0;
      right: 0;
      width: 65%;
      @media (max-width: 767px) {
        width: 100%;
      }
    }

    .rwa_delivery_page_021 {
      position: relative;
      width: 80%;
      margin-left: 10%;

      .rwa_delivery_page_0211 {
        width: 150px;
        color: #FFF;
        font-family: Montserrat;
        font-size: 26px;
        font-style: italic;
        font-weight: 900;
        line-height: 152%; /* 39.52px */
        margin: 100px 0 35px 0;
        cursor: pointer;
      }
      .rwa_delivery_page_0212 {
        display: flex;
        width: 270px;
        height: 40px;
        padding: 0 5px;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;
        border-radius: 13px;
        background: #232323;
        color: #999;
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-bottom: 30px;
        .rwa_delivery_page_0212_select {
          display: flex;
          height: 35px;
          padding: 8px 15px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          flex: 1 0 0;
          border-radius: 10px;
          background: #3D3D3D;
          color: #FFF;
        }
        .rwa_delivery_page_02121 {
          width: 50%;
          text-align: center;
          cursor: pointer;
        }
        .rwa_delivery_page_02122 {
          width: 50%;
          text-align: center;
          cursor: pointer;
        }
      }
      .rwa_delivery_page_0213 {
        width: 100%;
        height: auto;
        min-height: 700px;
        border-radius: 12px;
        border: 0.5px solid rgba(153, 153, 153, 0.30);
        background: #252525;
        .rwa_delivery_page_02131 {
          width: 100%;
          height: auto;
          min-height: 630px;
          margin-bottom: 20px;
          padding: 20px 20px 0 20px;

          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-content: flex-start;
          justify-content: flex-start;
          align-items: flex-start;

          .rwa_delivery_page_02131_div {
            width: 280px;
            height: 310px;
            border-radius: 16px;
            border: 1px solid rgba(153, 153, 153, 0.30);
            background: #313131;
            margin: 15px;

            @media (max-width: 767px) {
              zoom: 1.2;
            }
            .rwa_delivery_page_02131_div1 {
              width: 100%;
              img {
                width: 100%;
                height: 208px;
                border-top-left-radius: 16px;
                border-top-right-radius: 16px;
              }
              .rwa_delivery_page_02131_div11 {
                position: sticky;
                width: 100%;
                height: 35px;
                margin-top: -40px;
                line-height: 35px;
                text-align: center;
                color: #FFF;
                font-family: Roboto;
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                background: rgba(26, 207, 120, 0.50);
                z-index: 1;
              }
              .rwa_delivery_page_02131_div12 {
                position: sticky;
                width: 100%;
                height: 35px;
                margin-top: -40px;
              }
            }
            .rwa_delivery_page_02131_div2 {
              width: calc(100% - 20px);
              color: #FFF;
              font-family: Roboto;
              font-size: 18px;
              font-style: normal;
              font-weight: 700;
              line-height: normal;
              margin: 10px;
              white-space: nowrap;      /* 禁止换行 */
              overflow: hidden;         /* 超出部分隐藏 */
              text-overflow: ellipsis;  /* 显示省略号 */
            }
            .rwa_delivery_page_02131_div3 {
              width: calc(100% - 20px);
              margin-left: 10px;
              display: flex;
              padding: 8px 28px;
              justify-content: center;
              align-items: center;
              gap: 10px;
              align-self: stretch;
              border-radius: 8px;
              background: #419552;
              color: #FFF;
              font-family: Inter;
              font-size: 15px;
              font-style: normal;
              font-weight: 700;
              line-height: 24px; /* 160% */
              cursor: pointer;
            }
          }
        }
        .rwa_delivery_page_02132 {
          width: 100%;
          height: 630px;
          margin-bottom: 20px;
          line-height: 630px;
          text-align: center;
          font-size: 20px;
          color: #FFFFFF;
        }
        .rwa_delivery_page_02133 {
          width: 100%;
          height: 50px;
        }
      }
      .rwa_delivery_page_0214 {
        width: 100%;
        height: 400px;
        margin-top: 50px;
        margin-bottom: 50px;
        @media (max-width: 767px) {
          height: 580px;
        }
        .rwa_delivery_page_02141 {
          font-size: 17px;
          color: #FFFFFF;
          font-weight: 600;
          line-height: 30px;
        }
        .rwa_delivery_page_02142 {
          font-size: 15px;
          color: #d1d1d1;
          line-height: 30px;
        }
      }
    }
    .rwa_delivery_page_03 {
      width: 100%;
    }
  }
}
</style>

<style>
.rwa_delivery_div {
  .el-pagination {
    text-align: center;
  }
  .el-pagination.is-background .el-pager li {
    background-color: #313131;
    color: #999999;
    border-radius: 5px !important;
  }
  .el-pagination.is-background .el-pager li:hover {
    color: #20B26C !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #313131;
    border: 1.5px solid #20B26C;
    color: #20B26C;
  }
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    background-color: #313131;
    color: #999999;
    border-radius: 5px !important;
  }

  .rwa_delivery_dialog {
    width: 100%;
    height: auto;
    @media (max-width: 767px) {
      zoom: 1.25;
    }
    .rwa_delivery_dialog_1 {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .rwa_delivery_dialog_11 {
        color: #FFF;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px; /* 133.333% */
      }
      img {
        width: 25px;
        cursor: pointer;
      }
    }
    .rwa_delivery_dialog_2 {
      height: 245px;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      .rwa_delivery_dialog_21 {
        display: flex;
        padding: 15px;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        align-self: stretch;
        border-radius: 12px;
        border: 1px solid #4A4A4A;
        .rwa_delivery_dialog_211 {
          width: 100%;
          display: flex !important;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: center;
          .rwa_delivery_dialog_2111 {
            color: #999;
            font-family: Inter;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
          .rwa_delivery_dialog_2112 {
            color: #999;
            font-family: Inter;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
        }
        .rwa_delivery_dialog_212 {
          width: 100%;
          display: flex !important;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: center;
          .rwa_delivery_dialog_2121 {
            display: flex !important;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: nowrap;

            color: #FFF;
            font-family: "Plus Jakarta Sans";
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px; /* 150% */
            img {
              width: 20px;
              margin-left: 8px;
            }
          }
          .rwa_delivery_dialog_2122 {
            color: #FFF;
            font-family: "Plus Jakarta Sans";
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px; /* 150% */
          }
        }
      }
      .rwa_delivery_dialog_22 {
        display: flex;
        padding: 15px;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        align-self: stretch;
        border-radius: 12px;
        border: 1px solid #4A4A4A;
        .rwa_delivery_dialog_221 {
          width: 100%;
          display: flex !important;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: center;
          .rwa_delivery_dialog_2211 {
            color: #999;
            font-family: Inter;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
          .rwa_delivery_dialog_2212 {
            color: #999;
            font-family: Inter;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
        }
        .rwa_delivery_dialog_222 {
          width: 100%;
          display: flex !important;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: center;
          .rwa_delivery_dialog_2221 {
            display: flex !important;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: nowrap;

            color: #FFF;
            font-family: "Plus Jakarta Sans";
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px; /* 150% */
            img {
              width: 20px;
              margin-left: 8px;
            }
          }
          .rwa_delivery_dialog_2222 {
            color: #FFF;
            font-family: "Plus Jakarta Sans";
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px; /* 150% */
          }
        }
      }
      .rwa_delivery_dialog_23 {
        display: flex;
        padding: 8px 28px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        align-self: stretch;
        border-radius: 8px;
        background: #20944B;
        color: #FFF;
        text-align: center;
        font-family: "Plus Jakarta Sans";
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 30px; /* 187.5% */
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>